module.exports={
   "Vb": [],
   "Vm": [],
   "Vc": [],
   "Vg": [],
   "Vp": ["s", "m", "g"],
   "Vd": ["a", "v"]
}